import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";
import {SettingsSection, SettingsSectionTitleDict} from "../../../app/settings/@const";

// const debug = "ModuleDependencies"
const debug = false

export class ModuleDependencies extends ModuleProto {


    constructor(moduleConfig: JSONObject) {
        super(ModuleType.DEPENDENCIES, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Dependencies"

        this.description                = "Allows users to define and manage relationships between tasks, ensuring that dependencies are respected throughout the project."
        this.svgIcon                    = "isvg-dependencies"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.settingsSection            = SettingsSection.TASKS_PROJECTS
        this.typeLabel                  = SettingsSectionTitleDict[SettingsSection.TASKS_PROJECTS]
        this.settingsUrl                = "settings/dependencies"
        this.parentSection              = SettingsParentSection.TASKS_PROJECTS
        this.canDisable                 = false
    }
}
